import type { IModalFooter } from "libs/design-system/src/types/modal/modal_footer";
import { Button } from "../../Button";
import styles from "./modal-footer.module.scss";

export const ModalFooter = ({ btnsProps, isMobile, errorMsg, footerHint }: IModalFooter) => {
  return (
    btnsProps &&
    <section
      className={styles['modal-footer']}
      data-modal-footer-is-mobile={isMobile}
      tabIndex={-1}
    >
      {
        errorMsg &&
        <div className={styles['modal-footer__error-msg']}>
          {errorMsg}
        </div>
      }

      {
        footerHint &&
        <div className={styles['modal-footer__hint']}>
          {footerHint}
        </div>
      }

      {
        btnsProps &&
        <div className={styles['modal-footer__action-btns']}>
          {
            btnsProps.map((btn, index) => (
              <Button
                key={`modal-footer-btn-${index}`}
                size="lg"
                {...btn}
              />
            ))
          }
        </div>
      }
    </section>
  )
}
